// extracted by mini-css-extract-plugin
export default {"bar":"styles_bar__5uH4u"};